import { router } from "@superadmin/router";
import { LoadingSpinner } from "@voicely/ui-mui/components/LoadingSpinner";
import { ThemeContextProvider, useThemeMode } from "@voicely/ui-mui/theme/ThemeContext";
import { Suspense } from "react";
import { RouterProvider } from "react-router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ToastProvider() {
	const { mode } = useThemeMode();

	return <ToastContainer position="top-right" autoClose={5000} theme={mode} />;
}

function App() {
	return (
		<ThemeContextProvider>
			<Suspense fallback={<LoadingSpinner text="Loading..." />}>
				<RouterProvider router={router} />
				<ToastProvider />
			</Suspense>
		</ThemeContextProvider>
	);
}

export default App;
